export default __webpack_public_path__ + "static/manta-89a0eb505d482e797089fa2da62861e8.png";